
export default {
  SET_CUSTOMERS (state, customers) {
    state.customers = customers
  },
  SET_INFO_DB(state, payload){
    state.infoDB = payload
  },
  UPDATE_CUSTOMER(state, payload){
    const index = state.customers.findIndex(user => user.id == payload.id);
    state.customers.splice(index, 1, payload)
  }
}